import { IDirConfig, UploaderPreset } from "../../../types/protocolDefinitions";
import {v4 as uuidv4} from "uuid"
export type UploaderPresetOption = {
    value: UploaderPreset | "custom";
    label: string;
    extensions: string[];
    min_file_age: number;
};

export const UPLOADER_PRESETS: UploaderPresetOption[] = [
    { value: "intan_rhs", label: "Intan RHS Files", extensions: ["rhs"], min_file_age: 65 },
    { value: "hdf5", label: "HDF5 Files", extensions: ["h5", "hdf5"], min_file_age: 0 },
    { value: "ant_neuro", label: "ANT Neuro Files", extensions: ["cnt", "evt"], min_file_age: 0 },
    { value: "custom", label: "Custom", extensions: [], min_file_age: 0 },
];

export const getPresetDefaults = (preset: UploaderPreset | "custom"): { extensions: string[], min_file_age: number } => {
    const p = UPLOADER_PRESETS.find(p => p.value === preset);
    return p ? { extensions: p.extensions, min_file_age: p.min_file_age } : { extensions: [], min_file_age: 0 };
};

export const DEFAULT_DIR_CONFIG: IDirConfig = {
    id: uuidv4(),
    dir_path: undefined,
    recursive: true,
    uploader_preset: "intan_rhs",
    uploader_custom_extensions: undefined,
    after_upload: "backup"
};

export const generateId = (): string => uuidv4();
